import React from 'react'
import classNames from 'classnames'
import * as styles from './index.module.scss'

interface Props
  extends Omit<React.HTMLAttributes<HTMLImageElement>, 'src' | 'alt' | 'width' | 'height'> {
  borderWidth?: number
  color: string
  image: string
  label: string
  size: number
  svgImage?: string
}

export const AudienceSegmentThumbnail: React.FC<Props> = ({
  borderWidth = 4,
  className,
  color,
  image,
  label,
  size,
  // eslint-disable-next-line no-unused-vars
  svgImage,
  style = {},
  ...restProps
}) => {
  return (
    <img
      className={classNames(styles.root, className)}
      data-testid="audienceSegmentThumbnail"
      style={{ color, width: size, height: size, borderWidth, backgroundColor: color, ...style }}
      src={`${image}`}
      alt={label}
      {...restProps}
    />
  )
}
